import { AxiosResponse } from "axios";
import { ApiResponse } from "@/shared/types/api";
import axiosClient from "@/shared/lib/axios/axios";
import { API_ROUTES } from "@/users/api/config";
import { TUser } from "@/users/types/user";

export interface IGetUsersInput {}

export type IGetUsersResponse = TUser;

export interface IInviteUser {
  username: string,
  email: string,
  first_name: string,
  last_name: string,
}

export const getAllUsers = async () => {
  return axiosClient
    .get<IGetUsersInput, AxiosResponse<ApiResponse<IGetUsersResponse[]>>>(
      API_ROUTES.USER,
    )
    .then((res) => res.data);
};

export interface IGetUserByIdInput {
  id: number;
}

export type IGetUserByIdResponse = TUser;

export const getUserById = async (id: number) => {
  return axiosClient
    .get<IGetUserByIdInput, AxiosResponse<ApiResponse<IGetUserByIdResponse>>>(
      `${API_ROUTES.USER}${id}/`,
    )
    .then((res) => res.data);
};


export const inviteUser = (data: IInviteUser) => {
  return axiosClient.post<any, AxiosResponse<ApiResponse<any>>>(
    API_ROUTES.INVITE,
    {
      username: data.username,
      email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
    }
  ).then(data => data.data);
}

